export default function (subFlows, branchOnProductCodeFn) {

    return function (step, junction) {

        // start with the availability check if not in agent quote
        junction(subFlows.availability.entry, true);

        subFlows.availability.exits.productAvailable.onNext.branch(branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, subFlows.bopFlows, subFlows.wcFlows, 'contactDetails'));
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/config/_flowBegining.js
// module id = 2226
// module chunks = 0